import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, IconButton, MenuItem, Select, Typography } from '@mui/material';
import Header from 'components/Header';
import { preserveLeadingSpaces } from 'components/menu/PolicyManagement';
import Loading from 'components/Loading';
import Tiptap from 'components/Tiptap/Tiptap';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // 이전 버튼 아이콘
import Footer from 'components/Footer';
import { getPrivacyAPI } from 'apis/policy/policyAPI';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy() {
  const [privacyContent, setPrivacyContent] = useState<string>('');
  const [dates, setDates] = useState<string[]>([]);
  // 선택된 날짜를 저장할 상태
  const [selectedDate, setSelectedDate] = useState<string>('');
  const privacyEditorRef = useRef<any>(null);
  const navigate = useNavigate();
  // 다국어
  const { t } = useTranslation();

  const handleGoBack = () => {
    navigate(-1); // 이전 페이지로 이동
  };

  // 날짜 선택시, 특정 날짜로 content를 업데이트하는 함수
  const fetchContentByDate = async (date: string) => {
    try {
      const response = await getPrivacyAPI(date);
      const { content } = response.data;
      setPrivacyContent(preserveLeadingSpaces(content || ''));
    } catch (error) {
      console.error('날짜별 데이터 가져오기 실패:', error);
      setPrivacyContent(''); // 에러가 발생하면 빈 내용으로 초기화
    }
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const getPrivacyAPIResponse = await getPrivacyAPI();
        const { dates, content } = getPrivacyAPIResponse.data;
        // 개인정보처리
        setPrivacyContent(preserveLeadingSpaces(content || ''));
        setDates(dates || []);
        // console.log('getPrivacyAPIResponse.data', getPrivacyAPIResponse.data);
        // dates가 존재하고 길이가 0보다 클 경우에만 상태 업데이트
        if (dates && dates.length > 0) {
          const latestDate = dates.reduce((latest: string, current: string) => {
            return new Date(current) > new Date(latest) ? current : latest;
          }, dates[0]);

          setSelectedDate(latestDate);
        }
      } catch (error) {
        console.error('데이터 가져오기 실패 :', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div
      style={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header를 클릭하면 메인페이지로 이동 */}
      <Header />
      {/* 경계선 */}
      <Divider />
      <Box
        style={{
          flex: '1', // 남은 공간을 차지하도록 설정
          width: '100%',
          maxWidth: '1920px',
          margin: '16px auto'
        }}
        paddingX={8}
      >
        <Box display="flex" flexDirection="row" justifyContent="space-between" marginBottom={2}>
          <Box display="flex" alignItems="center" flexDirection="row" gap={1}>
            <IconButton onClick={handleGoBack} color="primary" aria-label="back">
              <ArrowBackIcon />
            </IconButton>
            {/* 개인정보처리방침 */}
            <Box display="flex" alignItems="center" justifyContent="center">
              <Typography variant="h5" fontWeight="bold">
                {t('footer.privacy')}
              </Typography>
            </Box>
          </Box>

          <Select
            value={selectedDate} // 선택된 날짜를 보여줌
            variant="outlined"
            size="small"
            sx={{ width: '150px' }}
            onChange={(e) => {
              const newValue = e.target.value as string; // 선택된 값
              setSelectedDate(newValue); // 상태 업데이트
              // console.log('Selected date:', newValue);
              fetchContentByDate(newValue); // 새로 선택된 날짜로 콘텐츠 가져오기
            }} // 값 변경 시 호출되는 핸들러
          >
            {/* dates 배열을 기반으로 MenuItem을 동적으로 생성 */}
            {dates.map((date) => (
              <MenuItem key={date} value={date}>
                {date}
              </MenuItem>
            ))}
          </Select>
        </Box>
        {/* 데이터가 존재하지 않을 때 로딩 메시지 또는 스피너 표시 */}
        {/*<Box boxShadow={1} borderRadius={1} bgcolor={theme.palette.tiptap.main}>*/}
        <Box boxShadow={1} borderRadius={1}>
          {!privacyContent ? <Loading /> : <Tiptap ref={privacyEditorRef} content={privacyContent} editable={false} maxHeight="calc(100vh - 300px)" />}
        </Box>
      </Box>
      <Footer maxWidth={1920} />
    </div>
  );
}
